import { render } from "./OfferHengxing.vue?vue&type=template&id=a8806052&scoped=true"
import script from "./OfferHengxing.vue?vue&type=script&lang=js"
export * from "./OfferHengxing.vue?vue&type=script&lang=js"

import "./OfferHengxing.vue?vue&type=style&index=0&id=a8806052&scoped=true&lang=css"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8806052"]])

export default __exports__